import { render, staticRenderFns } from "./QuantityButtonSmall.vue?vue&type=template&id=3c79c378&scoped=true"
import script from "./QuantityButtonSmall.vue?vue&type=script&lang=js"
export * from "./QuantityButtonSmall.vue?vue&type=script&lang=js"
import style0 from "./QuantityButtonSmall.vue?vue&type=style&index=0&id=3c79c378&scoped=true&lang=css"
import style1 from "./QuantityButtonSmall.vue?vue&type=style&index=1&id=3c79c378&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c79c378",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c79c378')) {
      api.createRecord('3c79c378', component.options)
    } else {
      api.reload('3c79c378', component.options)
    }
    module.hot.accept("./QuantityButtonSmall.vue?vue&type=template&id=3c79c378&scoped=true", function () {
      api.rerender('3c79c378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/QuantityButtonSmall.vue"
export default component.exports